import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

// Image data
const img = [
  { img: '/slider1.webp' },
  { img: '/slider2.webp' },
  { img: '/slider3.webp' },
  // { img: '/slider4.webp' },
  // { img: '/slider5.webp' },
];

function Slider() {
  return (
    <div className="my-2" style={{overflow:'hidden'}}>
      <Swiper
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        lazy={true}
        loop={true}
        style={{ overflow: 'hidden' }}
      >
        {img.map((slide, index) => (
          <SwiperSlide key={index}>
            <div style={{ width: '100%', aspectRatio: '16 / 6', position: 'relative' }}>
              <img
                src={slide.img}
                loading={index === 0 ? 'eager' : 'lazy'}
                className={`w-100 ${index !== 0 ? 'swiper-lazy' : ''}`}
                alt={'slide' + index}
                style={{
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
              />
              {index !== 0 && <div className="swiper-lazy-preloader"></div>}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Slider;